// Right after a submit the API has answered before its queue-driven notifier sends the email.
// The detail screen looks again a few times before it settles on "not sent yet".

export const SEND_CHECKS = 4
export const SEND_CHECK_MS = 1500

/**
 * After a load (`checksDone` re-checks already made), the delay before the next re-check, or
 * null to settle. Only a just-submitted order that was found and is still unsent is re-checked.
 */
export function nextSendCheck(submitted: boolean, found: boolean, sent: boolean, checksDone: number): number | null {
  if (!submitted || !found || sent || checksDone >= SEND_CHECKS) return null
  return SEND_CHECK_MS
}
